<template lang="pug">
v-app
  core-sidebar(
    v-if="logado",
    v-model="drawer",
    :menu-control-soft="menuControlSoft",
    :menu-sy-safra="menuSySafra",
    :enable-sysafra="enableSysafra",
    :active-route="activeRoute"
  )

  core-topbar(
    v-if="logado",
    :is-control="isControl",
    :title="title",
    :notification-status="notificationStatus",
    @toggle-drawer="drawer = !drawer"
  )

  v-main
    core-messages
    Loader
    core-dialog
    v-fade-transition(mode="out-in")
      router-view
</template>

<script>
import { mapMutations } from "vuex";
import csapi from "@/api/csapi";
import csaprod from "@/api/csaprod";
import { socket, state } from "@/socket";
import { getSidebarPermissions } from "@/utils/permissions";
import { getControlSoftMenu, getSysSafraMenu } from "@/utils/menus";

export default {
  data: () => ({
    enableSysafra: false,
    menuControlSoft: [],
    menuSySafra: []
  }),

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    logado() {
      if (["releases", "releasesVersao"].includes(this.$route.name)) {
        return false;
      }

      return !!this.user;
    },

    accessSySafra() {
      return this.$store.state.app.accessSySafra;
    },

    isControl() {
      const { isControl } = this.$store.state.app;
      return isControl;
    },

    drawer: {
      get() {
        return this.$store.state.app.drawer;
      },

      set(val) {
        this.setDrawer(val);
      }
    },

    title() {
      return this.$store.state.app.title;
    },

    notificationStatus() {
      return state.notificationStatus;
    },

    activeRoute() {
      return this.$route.path;
    }
  },

  watch: {
    user: {
      immediate: true,
      handler() {
        this.syncSidebarState();

        if (this.user && !socket.connected) {
          socket.connect();
        }
      }
    },

    async $route() {
      if (this.$store.state.auth.csapi) {
        const { expiresAt } = this.$store.state.auth.csapi;
        const now = new Date().getTime();
        if (!expiresAt || now > new Date(expiresAt).getTime()) {
          await this.$store.dispatch("auth/csApiLogin");
        }

        const { token } = this.$store.state.auth.csapi;
        csapi.addHeader("Authorization", `Bearer ${token}`);
      }

      if (this.$store.state.auth.csprod) {
        const { expiresAt } = this.$store.state.auth.csprod;
        const now = new Date().getTime();
        if (!expiresAt || now > new Date(expiresAt).getTime()) {
          await this.$store.dispatch("auth/csApiLoginProd");
        }

        const { token } = this.$store.state.auth.csprod;
        csaprod.addHeader("Authorization", `Bearer ${token}`);
      }
    },

    accessSySafra(newValue) {
      this.enableSysafra = newValue;
    }
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "setAccessSySafra", "toggleDrawer"]),

    syncSidebarState() {
      if (this.user === null) {
        this.setAccessSySafra(false);
        this.enableSysafra = false;
        this.$store.state.app.accessSocketControls = false;
        this.menuControlSoft = [];
        this.menuSySafra = [];
        return;
      }

      const permissions = getSidebarPermissions(this.user);

      this.setAccessSySafra(permissions.accessSySafra);
      this.enableSysafra = permissions.accessSySafra;
      this.$store.state.app.accessSocketControls = permissions.accessSocketControls;

      this.menuControlSoft = getControlSoftMenu(permissions);
      this.menuSySafra = getSysSafraMenu();
    }
  },

  mounted() {
    this.setDrawer(false);

    if (localStorage.getItem("ipConfigCrypt") === null) {
      localStorage.setItem("ipConfigCrypt", new Date().getTime());
      this.$store.dispatch("auth/logout");
      return;
    }

    const lastConnection = new Date(
      parseInt(localStorage.getItem("ipConfigCrypt"), 10)
    ).toLocaleDateString();
    const now = new Date().toLocaleDateString();

    if (lastConnection !== now) {
      localStorage.setItem("ipConfigCrypt", new Date().getTime());
      this.$store.dispatch("auth/logout");
      return;
    }

    if (!socket.connected) {
      socket.connect();
    }
  },

  beforeDestroy() {
    if (socket.connected) {
      socket.disconnect();
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/index.scss";
</style>
